import '../newsItems.scss';
import AddEventModal from './AddEventModal';
import ContentSearchPage from '../ContentSearchPage';

const columns = ['photo', 'headline', 'date', 'city', 'status'];
const searchFields = [
  { name: 'headline', label: 'Event name' },
  { name: 'city', label: 'City' },
  { name: 'status', label: 'Status' },
  { name: 'time', label: 'Occurrences' },
  { name: 'promoted', label: 'Promoted' },
  { name: 'scheduled', label: 'Scheduled' },
  { name: 'occurrence', label: 'Occurrences' },
];

const EventsPage = () => (
  <ContentSearchPage
    pageTitle="Events"
    columns={columns}
    searchFields={searchFields}
    addItemModal={<AddEventModal />}
    pageIcon="star outline"
    contentType="event"
  />
);
export default EventsPage;
